import React from "react";
import { useLocalization } from "../../providers/LocalizationProvider";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./Dialog";
import { Button } from "./Button";

export default function EditorModal({ open, title, children, onClose, onSubmit, submitLabel }){
  const { t } = useLocalization();
  
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-[700px] max-w-[95vw]">
        <form onSubmit={onSubmit} className="w-full min-w-0 max-w-full overflow-hidden flex flex-col h-full">
          <DialogHeader className="flex-shrink-0">
            <DialogTitle className="text-base sm:text-lg">{title}</DialogTitle>
          </DialogHeader>
          <div className="py-2 sm:py-4 w-full min-w-0 max-w-full flex-1 overflow-y-auto">
            {children}
          </div>
          <DialogFooter className="flex-shrink-0 pt-2 sm:pt-4">
            <Button type="button" variant="outline" onClick={onClose} className="w-full sm:w-auto">
              {t('common.cancel')}
            </Button>
            <Button type="submit" className="w-full sm:w-auto">
              {submitLabel || t('common.save')}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}